import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Link, useSearchParams, useNavigate} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {formatDate, formatPhoneNumber} from "page/util/helpers";

export default function Main() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [paginationDto, setPaginationDto] = useState();
    const [contents, setContents] = useState([]);

    const navigate = useNavigate();

    const page = searchParams.get('page') || "1";
    const messageType = searchParams.get('messageType') || "";
    const sendType = searchParams.get('sendType') || "";
    const searchText = searchParams.get('searchText') || "";
    const membershipType = searchParams.get('membershipType') || "";

    const requestSearch = (e) => {
        const params = {};
        params.page = page;
        params.messageType = messageType;
        params.sendType = sendType;
        params.searchText = searchText;
        params.membershipType = membershipType;

        axios.get(`/admin/push/messages`, {params: params})
            .then((res) => {
                setPaginationDto(res.data);
                setContents(res.data.content);
            });
    }

    const displayMessageType = (messageType) => {
        switch (messageType) {
            case "INFORMATION": return "정보성";
            case "MARKETING": return "광고성";
            default: return "";
        }
    }

    const displaySendType = (sendType) => {
        switch (sendType) {
            case "IMMEDIATE": return "즉시 발송";
            case "SCHEDULED": return "예약 발송";
            case "RECURRING": return "반복 발송";
            default: return "";
        }
    }

    const displayMembershipType = (membershipType) => {
        switch (membershipType) {
            case "BASIC": return "BASIC";
            case "BUSINESS": return "BUSINESS";
            default: return "전체";
        }
    }

    const displaySendAt = (pushMessage) => {
        switch (pushMessage.sendType) {
            case "IMMEDIATE": return "-";
            case "SCHEDULED": return formatDate(pushMessage.schedule.sendAt);
            case "RECURRING": return pushMessage.recurring.sendTime;
        }
    }

    const setPage = (page) => {
        searchParams.set('page', page);
        setSearchParams(searchParams)
    }

    useEffect(() => {
        requestSearch();
    }, []);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">푸시메시지 - 목록</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">

                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: '40px'}}>
                                            <div className="form-group row" style={{float: "right"}}>

                                                <label className="col-sm-auto col-form-label"
                                                       style={{marginLeft: '10px'}}>푸시타입</label>

                                                <select className="form-control float-right"
                                                        style={{width: '120px', marginRight: '20px'}}
                                                        onChange={e => {
                                                            searchParams.set('messageType', e.target.value);
                                                            setSearchParams(searchParams);
                                                        }}
                                                        value={messageType}>
                                                    <option value="">전체</option>
                                                    <option value="INFORMATION">정보성</option>
                                                    <option value="MARKETING">광고성</option>
                                                </select>

                                                <label className="col-sm-auto col-form-label"
                                                       style={{marginLeft: '10px'}}>전송방식</label>

                                                <select className="form-control float-right"
                                                        style={{width: '120px', marginRight: '20px'}}
                                                        onChange={e => {
                                                            searchParams.set('sendType', e.target.value);
                                                            setSearchParams(searchParams);
                                                        }}
                                                        value={sendType}>
                                                    <option value="">전체</option>
                                                    <option value="IMMEDIATE">즉시발송</option>
                                                    <option value="SCHEDULED">예약발송</option>
                                                    <option value="RECURRING">반복발송</option>
                                                </select>

                                                <label className="col-sm-auto col-form-label"
                                                       style={{marginLeft: '10px'}}>요금제</label>

                                                <select className="form-control float-right"
                                                        style={{width: '120px', marginRight: '20px'}}
                                                        onChange={e => {
                                                            searchParams.set('membershipType', e.target.value);
                                                            setSearchParams(searchParams);
                                                        }}
                                                        value={membershipType}>
                                                    <option value="">전체</option>
                                                    <option value="BASIC">BASIC</option>
                                                    <option value="BUSINESS">BUSINESS</option>
                                                </select>

                                                <label className="col-sm-auto col-form-label"
                                                       style={{marginLeft: '10px'}}>검색어</label>

                                                <input type="text" className="form-control"
                                                       style={{width: '250px', marginRight: '20px'}}
                                                       onChange={ e=> {
                                                           searchParams.set('searchText', e.target.value);
                                                           setSearchParams(searchParams);
                                                       }}
                                                       onKeyDown={e => {
                                                           if (e.key === 'Enter') {
                                                               setPage(1);
                                                               requestSearch();
                                                           }
                                                       }}
                                                       value={searchText}
                                                       placeholder=''/>

                                                <button type="submit" className="btn btn-info float-right"
                                                        style={{width: '80px', marginRight: '20px'}}
                                                        onClick={ () => {
                                                            setPage(1);
                                                            requestSearch();
                                                        }}>
                                                    검색
                                                </button>

                                            </div>
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{marginTop: '0px'}}>
                                            <table className="table table-hover text-nowrap"
                                                   style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>SEQ</th>
                                                    <th>메시지 종류</th>
                                                    <th style={{width: "50%"}}>제목</th>
                                                    <th>전송방식</th>
                                                    <th>발송 일자/시간</th>
                                                    <th>대상</th>
                                                    <th>
                                                        <button type="submit" className="btn-sm btn-success"
                                                                style={{padding: '2px 8px'}}
                                                                onClick={ () => { navigate(`/page/push/message/detail`) }}>
                                                            추가
                                                        </button>
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    contents && contents.map(item => {
                                                        return (
                                                            <tr key={item.id}>
                                                                <td>{item.id}</td>
                                                                <td>{displayMessageType(item.messageType)}</td>
                                                                <td>{item.title}</td>
                                                                <td>{displaySendType(item.sendType)}</td>
                                                                <td>{displaySendAt(item)}</td>
                                                                <td>{displayMembershipType(item.membershipType)}</td>
                                                                <td>
                                                                    <button type="button"
                                                                            className="btn btn-outline-primary btn-sm"
                                                                            onClick={ () => { navigate(`/page/push/message/detail?id=${item.id}`) }}>
                                                                        보기
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        { paginationDto && <Pagination pager={paginationDto} setPage={setPage}/> }
                    </section>

                </div>
            </div>
        </div>
    );
}


